import * as React from 'react';

const Rotate36016 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2 12.792a.5.5 0 0 0 .854.354l.911-.912A6 6 0 0 0 8 14a6 6 0 0 0 5.464-3.538c.213-.471-.165-.962-.683-.962-.334 0-.626.214-.776.512A4.48 4.48 0 0 1 8 12.5a4.5 4.5 0 0 1-3.176-1.323l.823-.824a.5.5 0 0 0-.354-.853H2.5a.5.5 0 0 0-.5.5zM8 2a5.97 5.97 0 0 1 4.235 1.765l.911-.911a.5.5 0 0 1 .854.353V6a.5.5 0 0 1-.5.5h-2.793a.5.5 0 0 1-.353-.854l.822-.822A4.47 4.47 0 0 0 8 3.5a4.48 4.48 0 0 0-4.005 2.488c-.15.298-.442.512-.777.512-.517 0-.895-.491-.682-.962A6 6 0 0 1 8 2"
  }
));
Rotate36016.Size = 36016;
Rotate36016.Title = "Rotate";

export { Rotate36016 as default };
